// removed by extract-text-webpack-plugin
module.exports = {"outView":"outView___2iEPk","topArea":"topArea___3cmo-","mainImg":"mainImg___1CSyg","itemView":"itemView___1xQEj","name":"name___1cd4i","value":"value___1UNZP","bottomView":"bottomView___1-7kP","title":"title___30Rv3","priceText":"priceText___1VRc3","priceUnit":"priceUnit___1u-__","codeArea":"codeArea___3F7fx"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Shop/Home/ShopHome/components/Tabs/Components/GoodsItem/index.modules.less
// module id = 723
// module chunks = 431